import { Button, Card  } from '@chakra-ui/react';
import type { CardRootProps } from '@chakra-ui/react';
import React from 'react';

type JobSearchTabProps = {

} & CardRootProps;

export const JobSearchTab = (props: JobSearchTabProps) => {
	return (
		<Card.Root {...props}>
			<Card.Header>Search Tab</Card.Header>
			<Card.Body>Content</Card.Body>
			<Card.Footer>
				<Button colorScheme="blue" width="100%">Search</Button>
			</Card.Footer>
		</Card.Root>
	);
};
